<template>
  <div class="amount-guide-dialog">
    <div>
      <v-dialog
        v-model="isOpen"
        width="90%"
        max-width="350px"
        data-app
        hide-overlay
      >
        <v-card class="amount-guide-dialog__card">
          <v-card-title class="title">
            '펀다나우' 이용 가능 금액 기준
          </v-card-title>

          <v-card-text class="content">
            <p><strong>① 총한도 - ② 대출잔액 = ③ 이용 가능 금액</strong><br />
            상점에서 발생하는 매출을 분석하여 매일 <strong>① 총한도</strong>가 부여되고 상환과 대출이 발생할 때 마다 변경됩니다.</p>
            <p>고객님 화면에서 <strong>① 총한도 10,000,00 원 - ② 대출 잔액 5,000,000 원 일 경우 = ③ 이용 가능 금액에 5,000,000 원</strong>으로 표기되어 원클릭 신청버튼이 파란색으로 활성화되어 신청이 가능합니다.</p>
            <p>반대로 당일 발생한 <strong>① 총한도 5,000,00 원보다 ② 대출 잔액이 10,000,000 원으로 더 많을 경우 이용 가능 금액은 - 원</strong>으로 표기되며 추가로 이용 가능한 금액은 없습니다.</p>
            <p>* 단, 1만원 이상 상환되지 않거나 추가로 발생된 금액이 10만원 미만일 경우 이용 가능금액에 추가 한도가 발생되지 않습니다.</p>
          </v-card-text>

          <v-card-text class="button-wrapper">
            <button
              @click="$emit('update:isOpen', false)"
            >
              확인
            </button>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  created() {
  }
}
</script>
<style lang="scss">
.amount-guide-dialog {
  width: 100%;
  height: 100vh;
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 999;

  .v-dialog {
    position: fixed;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    border-radius: 8px;

    &__container {
      display: unset;
    }
  }

  &__card {
    border-radius: 8px;

    .title {
      width: 100%;
      text-align: center;
      padding: 20px 24px 20px !important;
      font-weight: 900 !important;
      color: #333333;
    }

    .content {
      p {
        padding-left: 12px;
        text-align: left;
        color: #333333;
        float: none;
        position: relative;

        &::before {
          position: absolute;
          content: "·";
          left: 0;
        }

        &:not(:last-child) {
          margin-bottom: 15px;
        }

        &:last-child {
          margin-top: 5px;
          &::before {
            display: none;
          }
        }

        span {
          display: inline;
          &.strong {
            font-weight: 900;
          }
        }
      }
    }

    .button-wrapper {
      padding: 0 !important;

      button {
        width: 100%;
        height: 60px;
        background-color: #333333;
        color: white;
        font-size: 20px;
        font-weight: 900;
      }
    }
  }
}

@media screen and (min-height: 630px) {
  .amount-guide-dialog {
    .v-dialog {
      top: 10%;
    }
  }
}
</style>
